export class ValidationRuleDefinitionDTO{
    public id!: number;
    public name!: string;
    public description!: string;
    public inputDataType!: string;
    public parameterCount!: number;
    public parameterLabels!: string;
}